<template>
  <div>

    <v-card v-for="room in availability.rooms" :key="room.id" class="ma-2" outlined>

      <v-card-title class="text-capitalize">
        {{room.name}}
        <v-spacer/>
        <v-chip label :color="room.available === 0 ? 'error' : 'success'">
          <v-icon small class="mr-2">mdi-home</v-icon>
          Disponibilitate: {{room.available}}
        </v-chip>
      </v-card-title>

      <v-divider class="mx-4"/>

      <v-row no-gutters>

        <v-col cols="12" md="4" v-if="getSmallRoomImage(room)">
          <v-card flat>
            <v-card-text>
              <v-img
                :src="getLargeRoomImage(room)"
                :lazy-src="getSmallRoomImage(room)"
                :aspect-ratio="16/9"
              />
            </v-card-text>
          </v-card>
        </v-col>

        <v-divider v-if="getSmallRoomImage(room)" vertical class="my-4"/>

        <v-col>
          <v-card v-for="(rate, index) in room.prices" flat :key="rate.id">

            <v-card-title>
              <v-row no-gutters>
                <v-col cols="8" class="text-left pa-0 title text-capitalize font-weight-light">
                  {{rate.name}}
                </v-col>
                <v-col cols="4" class="text-right pa-0">
                  <im-price
                    :font-size="20"
                    :price="rate.price"
                    :currency="rate.currency"
                  />
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-text>
              <v-row no-gutters>
                <v-col cols="6" class="text-left body-2">
                  <v-row no-gutters>
                    <v-col cols="12">

                      <v-row no-gutters v-if="rate.occupancy.adults === 1">
                        <v-icon class="mr-2" small>mdi-account</v-icon>
                        Capacitate de {{ rate.occupancy.adults }} adult.
                      </v-row>
                      <v-row no-gutters v-if="rate.occupancy.adults === 2">
                        <v-icon class="mr-2" small>mdi-account-multiple</v-icon>
                        Capacitate de {{ rate.occupancy.adults }} adulți.
                      </v-row>
                      <v-row no-gutters v-if="rate.occupancy.adults >= 3">
                        <v-icon class="mr-2" small>mdi-account-multiple-plus</v-icon>
                        Capacitate de {{ rate.occupancy.adults }} adulți.
                      </v-row>

                      <v-row no-gutters v-if="rate.meal_type === 'all-inclusive'">
                        <v-icon class="mr-2" small>mdi-silverware-fork-knife</v-icon>
                        All Inclusive
                      </v-row>
                      <v-row no-gutters v-if="rate.meal_type === 'breakfast'">
                        <v-icon class="mr-2" small>mdi-coffee</v-icon>
                        Micul dejun inclus in preț.
                      </v-row>
                      <v-row no-gutters v-if="rate.meal_type === 'lunch'">
                        <v-icon class="mr-2" small>mdi-noodles</v-icon>
                        Prânzul inclus in preț.
                      </v-row>
                      <v-row no-gutters v-if="rate.meal_type === 'dinner'">
                        <v-icon class="mr-2" small>mdi-food-variant</v-icon>
                        Cina inclusă in preț.
                      </v-row>

                      <v-row v-if="rate.cancellation_policy.free_cancellation" no-gutters class="success--text">
                        <v-icon class="mr-2 light-green--text" small>mdi-thumb-up-outline</v-icon>
                        Rambursabil
                      </v-row>
                      <v-row v-if="!rate.cancellation_policy.free_cancellation" no-gutters class="warning--text">
                        <v-icon class="mr-2 warning--text" small>mdi-alert-outline</v-icon>
                        Nerambursabil
                      </v-row>

                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="6" class="text-right">
                  <v-sheet class="pa-0 grey lighten-2 d-inline-flex " style="height: 40px; border-radius: 90px;">
                    <v-btn color="primary" dark depressed small fab @click="decRateQuantity(room, rate)" :disabled="!rate.quantity">
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                    <span class="my-2 mx-3 font-weight-bold">{{rate.quantity || 0}}</span>
                    <v-btn color="primary" dark depressed small fab @click="incRateQuantity(room, rate)" :disabled="!room.available">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-sheet>
                </v-col>

              </v-row>
            </v-card-text>

            <v-divider v-if="index < room.prices.length - 1" class="mx-3"/>

          </v-card>
        </v-col>
      </v-row>

    </v-card>

  </div>
</template>

<script>

  import IMPrice from '../utils/IMPrice.vue';

  export default {

    components: {
      'im-price': IMPrice
    },

    props: {
      hotel: {
        type: Object,
        default: () => null
      },
      availability: {
        type: Object,
        default: () => null
      }
    },

    data: () => ({
      modal: false,
      room: null
    }),

    methods: {

      getLargeRoomImage(room) {
        let hotel_room = this.hotel.rooms.find(r => r.id === room.id);
        return this.$_.get(hotel_room, 'media[0].url.large');
      },

      getSmallRoomImage(room) {
        let hotel_room = this.hotel.rooms.find(r => r.id === room.id);
        return this.$_.get(hotel_room, 'media[0].url.small')
      },

      getRoomAvailable(room) {
        return room.available || 0;
      },

      getRateQuantity(rate) {
        return rate.quantity || 0;
      },

      incRateQuantity(room, rate) {
        let quantity = this.getRateQuantity(rate);
        let available = this.getRoomAvailable(room);

        quantity = (available <= 0) ? quantity : ++quantity;
        available = (available <= 0) ? 0 : --available;

        this.$set(rate, 'quantity', quantity);
        this.$set(room, 'available', available);

        sessionStorage.setItem('availability', JSON.stringify(this.availability));
      },

      decRateQuantity(room, rate) {
        let available = this.getRoomAvailable(room);
        let quantity = this.getRateQuantity(rate);

        available = (quantity <= 0) ? available : ++available;
        quantity = (quantity <= 0) ? 0 : --quantity;

        this.$set(room, 'available', available);
        this.$set(rate, 'quantity', quantity);

        sessionStorage.setItem('availability', JSON.stringify(this.availability));
      }

    }

  }
</script>
